import async from 'async';
import {_str,xtract} from 'h2g-test-results/js/util';
import {getCurrent_NetworkID_BSSID} from 'h2g-test-results/js/test-results';

 var DEVICELIST = {
  showBusyState :null,
  hideBusyState : null,
  totalDisplayedItems : 15,
  nw_id:null,
  get_son : null,
  devlist : [],
  device_type_map : {},
  device_type_icon_map : {},
  connection_type_icon_map : {},
  connection_type_map : {},
  init : function($scope,$stateParams){
   $scope.noDeviceFound = "";
   DEVICELIST.showBusyState();
   $scope.component = $stateParams && $stateParams.p;
   $scope.h2gLogo= WTG.img("app_icon.svg");
   $scope.phIcon= WTG.img("phone_icon.svg");
   $scope.btrIcon= WTG.img("battery_30.svg");
   $scope.btrCharg= WTG.img("ic_battery_charg.svg");
   $scope.btrPlug= WTG.img("ic_battery_plug.svg");
   $scope.stIcon= WTG.img("speed_test_icon.svg");
   DEVICELIST.totalDisplayedItems =15; //show number of items to be load on a list
   $scope.tapEntry = _str("tap_entry");
   $scope.localNetworkStatus = _str("local_network_details_status");
   $scope.localNetworkDeviceName = _str("local_network_details_device_name");
   $scope.localNetworkType = _str("local_network_details_type");
   $scope.localNetworkLastSeen = _str("local_network_details_last_seen");
  },
  lan_scan_list : function($scope,nwid){
   DEVICELIST.device_type_map = {1:"gateway",2:"access_point",3:"printer",4:"media_server",5:"tv_receiver",
    100:"computer",101:"gaming_console",102:"mobile",103:"phone",104:"tablet",
    901:"laptop",902:"desktop"
   };
   DEVICELIST.connection_type_icon_map = {"lan": WTG.img("ic_lan.svg"),
    "wifi": WTG.img("ic_wifi.svg"),
    "NA": WTG.img("ic_unknown_conn.svg")
   };
   DEVICELIST.device_type_icon_map = {"gateway": WTG.img("router_icon.svg"),
    "access_point": WTG.img("router_icon.svg"),
    "printer": WTG.img("printer_icon.svg"),
    "media_server": WTG.img("media_server.svg"),
    "desktop": WTG.img("desktop_icon.svg"),
    "tv_receiver": WTG.img("tv_icon.svg"),
    "computer": WTG.img("computer_icon.svg"),
    "gaming_console": WTG.img("gaming_console.svg"),
    "mobile": WTG.img("phone_icon.svg"),
    "laptop": WTG.img("laptop_icon.svg"),
    "phone": WTG.img("phone_icon.svg"),
    "tablet": WTG.img("tablet_icon.svg"),
    "NA": WTG.img("na_icon.svg")
   };
   DEVICELIST.connection_type_map = {1:_str("conn_type_lan_str"),2:_str("conn_type_wifi_str"),3:_str("conn_type_others_str")};
   if(!nwid) nwid = (getCurrent_NetworkID_BSSID($scope.component)||{}).network_id||'';
   DEVICELIST.getNetworkScanDevicesList(nwid,DEVICELIST.device_type_map,DEVICELIST.connection_type_map,DEVICELIST.device_type_icon_map,DEVICELIST.connection_type_icon_map,function(e,r) {
    DEVICELIST.devlist = [];
    if(e) L.error({err:e},"Error retrieving network devices list");
    $scope.devices = r||[];
    DEVICELIST.hideBusyState();
    DEVICELIST.setDeviceList($scope.devices);
    if(!$scope.devices.length) {
     DEVICELIST.hideBusyState();
     $scope.noDeviceFound = _str("local_network_no_devices_found");
    }
    setTimeout(function() {$scope.$apply()},0);
   });
  },
  controller : function device_list_ctrl($scope){
   $scope.asc = true;
   $scope.myOrder = ['status'];
   $scope.showBtrIndicator = !DEVICELIST.show_p2p_details();
   $scope.showChargingStatus = function(cs,dt){
    var device= DEVICELIST.device_type_map[dt];
    if(cs &&(dt=="mobile" || device=="phone" || device =="tablet")) return WTG.img("ic_battery_charg.svg");
    if(cs) return WTG.img("ic_battery_plug.svg");
    return "";
   };
   $scope.showBtrLevel = function(bl){
    return bl+'%';
   };
   $scope.isDeviceUnPlugged = function(cs,bl){
    if(cs) return;
    if(!bl) return ((cs === false) && (bl === false));
    return true;
   };
   $scope.changeDeviceStatusColor = function(status) {
    return DEVICELIST.getStatusClr(status);
   };
  },
  getTimeStampForUI : function(unixTimeStamp){
   unixTimeStamp = parseInt(unixTimeStamp);
   if(!unixTimeStamp) return "NA";
   var dt = new Date(unixTimeStamp*1000);
   function getTwoDigitValue(input) {
    input = input.toString();
    if(input.length==1) return "0"+input;
    return input;
   }
   return (dt.getDate()==new Date().getDate())?(getTwoDigitValue(dt.getHours())+":"+getTwoDigitValue(dt.getMinutes())+":"+getTwoDigitValue(dt.getSeconds())):(getTwoDigitValue(dt.getDate())+"."+(getTwoDigitValue(dt.getMonth()+1))+"."+dt.getFullYear().toString().substr(2,2));
  },
  setDeviceList :function(dl){
   DEVICELIST.devicelist = dl;
  },
  getDeviceList :function(){
   return DEVICELIST.devicelist || "";
  },
  getKeyByValue : function(obj,val){
   for(var key in obj) { if(obj[key] == val) return key; }
  },
  show_p2p_details : function() {
   return (C11N.brand.toLowerCase()!="baltcom");
  },
  getStatusClr :function(status){
   var val,low_qual=2,online=3;
   val = status? '#BF4D4A' : 'gray';
   if(status==low_qual) val = '#D1A92F';
   else if (status==online) val = '#749935';
   return val;
  },
  getData: function(table,cb) {
   if(C11N.is_portal) DEVICELIST.get_json(table,cb);
   else get_json(table,cb);
  },
  getNetworkScanDevicesList : function(netid,devtype_names,conntype_names,devtype_icons,conType_icons,cb){
   if(!netid) return cb(new Error('not getting device list for unknown network'));
   DEVICELIST.getData('Network Devices.'+netid,function(e,ndevs){
    DEVICELIST.prepareNetworkScanDeviceList(e,ndevs,netid,devtype_names,conntype_names,devtype_icons,conType_icons,cb);
   });
  },
  prepareNetworkScanDeviceList : function(e,ndevs,netid,devtype_names,conntype_names,devtype_icons,conType_icons,cb){
   if(e || !ndevs) return cb(e);
   async.forEachOf(ndevs,function(devdata,devid,cb) {
    if(!devid) return cb();
     async.parallel({
      mon: function(cb) {
       DEVICELIST.getData('Monitor devices.'+devid,function(e,r) {
        // TODO: eventually only fallback in case of notfound error
        cb(null,e?0:r.Monitor);
       });
      },
      dd: DEVICELIST.getData.bind(null,'Devices.'+devid)
     },function(e,r) {
        if(e) return cb(e);
        var dd = r.dd;
        var data = {
         devid: devid,
         MAC: dd['MAC address'],
         h2gApp:(dd["App Version"] && DEVICELIST.show_p2p_details())?true:false,
         dev_charging:dd["Device Charging"],
         battery_level:dd.Battery,
         foreground_app:dd['Foreground App'],
         currNetworkID: netid,   // XXX: why is it needed for each device on the list?
         deviceType: xtract(dd,'User defined.Type')||'NA',
         monitor: !!r.mon,
         name: (xtract(dd,'User defined.Name')||'').trim()||(devdata['Display Name']||'').trim()||devdata.IP||'NA',
         connectionType: xtract(devdata,'User defined.Connection Type')||devdata['Connection Type']||'NA',
         status: devdata.Online?devdata["Connection quality color 1"]||3:0, //when connection quality color is unknown, but device is online, show green which is 3.
         con_qual_dbg_inf:devdata["Connection quality debug info"],
         IP: devdata.IP||'NA',
         lastSeen: devdata['Last seen']||'',
         RTT: devdata['Roundtrip Time']?devdata['Roundtrip Time']+'ms':'NA',
         manufacturer: (xtract(dd,'MAC Vendor.Name')||'').trim()||'NA',
         cpu_usage: dd['CPU usage']||'',
         dev_model: dd['Device model']||'',
         data_usage: dd['Internet usage']||''
        };
        data.timeStamp = DEVICELIST.getTimeStampForUI(data.lastSeen);
        if(dd) {
         var ddt = dd['Display Device Type'];
         if(data.deviceType=='NA' && ddt) data.deviceType = ddt;
         // handle old user defined types which were stored in strings
         // so fetch number which is a "key" in "devtype_names"
         if(data.deviceType != "NA" && isNaN(data.deviceType)) {
          data.deviceType = data.deviceType.toLowerCase().replace(/\s/g, '_');
          data.deviceType = DEVICELIST.getKeyByValue(devtype_names,data.deviceType);
          //better we save back the number type when we know ??
         }
         data.img=devtype_icons[devtype_names[data.deviceType]||"NA"];
        }
        // handle old user defined connection types which were stored in strings
        if(data.connectionType!='NA' && isNaN(data.connectionType)) {
         data.connectionType = DEVICELIST.getKeyByValue(conntype_names,data.connectionType.toLowerCase());
        }
        data.conImg=conType_icons[conntype_names[data.connectionType] || 'NA'];
        DEVICELIST.devlist.push(data);
        cb();
       });
   },function(e/*,r*/){cb(e,DEVICELIST.devlist)});
  }
 };

export default DEVICELIST;
